// extracted by mini-css-extract-plugin
export default {"parentLayout":"Layout_parentLayout__-Nt40"};